// extracted by mini-css-extract-plugin
export default {"entries":"DisplayGoalDetail_entries__rSUJo"};